export default {
  name: 'NumberInput',
  props: {
    value: {
      type: Number | String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
      default: 100
    },
    classname: {
      type: String,
      default: ''
    },
    maxValue: {
      type: Number,
      default: null
    },
    minValue: {
      type: Number,
      default: null
    },
    precision: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      content: this.value
    }
  },
  methods: {
    onWrite (e) {
      let val = this.content
      val = val + '';
      val = val.replaceAll(',', '.');
      const numberVal = parseFloat(val);
      if (isNaN(numberVal) && val !== '-') {
        val = '';
      }
      if (!isNaN(numberVal)) {
        if (this.maxValue && numberVal > this.maxValue) {
          val = this.maxValue + '';
        }
        if (this.minValue && numberVal < this.minValue) {
          val = this.minValue + '';
        }
      }
      val = val.replace(/^(-)|[^0-9.]+/g, '$1');
      if (this.precision === 0 && val != '') {
        val = parseInt(val);
      } else if (this.precision) {
        const parts = val.split('.');
        val = parts[0];
        if (parts.length > 1) {
          val += '.' + parts[1].substring(0, this.precision);
        }
      }
      this.updateValue(val);
    },
    updateValue (val) {
      this.content = val;
      this.$emit('input', this.content);
    }
  }
}
